import { render, staticRenderFns } from "./promotional-modal.vue?vue&type=template&id=3da90c6e&scoped=true&"
import script from "./promotional-modal.vue?vue&type=script&lang=js&"
export * from "./promotional-modal.vue?vue&type=script&lang=js&"
import style0 from "./promotional-modal.vue?vue&type=style&index=0&id=3da90c6e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da90c6e",
  null
  
)

export default component.exports